import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../assets/img/default-avatar.png'
import _imports_1 from '../../assets/img/unlink-line-icon.png'


const _hoisted_1 = { class: "modal-edit-profile-page-section" }
const _hoisted_2 = { class: "modal-dialog-right" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "modal-title" }, "แก้ไขโปรไฟล์ของฉัน", -1)
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "body-title" }
const _hoisted_8 = { class: "body-title-avatar" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "body-title-name" }
const _hoisted_11 = { class: "body-info" }
const _hoisted_12 = { class: "body-info-general" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 3,
  class: "skeleton-outlined"
}
const _hoisted_15 = { class: "skeleton-control" }
const _hoisted_16 = { class: "skeleton-control-field" }
const _hoisted_17 = {
  key: 5,
  class: "skeleton-outlined"
}
const _hoisted_18 = { class: "skeleton-control" }
const _hoisted_19 = { class: "skeleton-control-field" }
const _hoisted_20 = {
  key: 7,
  class: "skeleton-outlined"
}
const _hoisted_21 = { class: "skeleton-control" }
const _hoisted_22 = { class: "skeleton-control-field" }
const _hoisted_23 = { class: "skeleton-control-icon" }
const _hoisted_24 = {
  key: 9,
  class: "skeleton-outlined"
}
const _hoisted_25 = { class: "skeleton-control" }
const _hoisted_26 = { class: "skeleton-control-field" }
const _hoisted_27 = { class: "skeleton-control-icon" }
const _hoisted_28 = {
  key: 11,
  class: "skeleton-outlined"
}
const _hoisted_29 = { class: "skeleton-control" }
const _hoisted_30 = { class: "skeleton-control-field" }
const _hoisted_31 = { class: "skeleton-control-icon" }
const _hoisted_32 = { class: "body-info-contact" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("แก้ไข")
const _hoisted_35 = {
  key: 3,
  class: "skeleton-outlined"
}
const _hoisted_36 = { class: "skeleton-control" }
const _hoisted_37 = { class: "skeleton-control-field" }
const _hoisted_38 = { class: "skeleton-control-icon" }
const _hoisted_39 = {
  key: 5,
  class: "skeleton-outlined"
}
const _hoisted_40 = { class: "skeleton-control" }
const _hoisted_41 = { class: "skeleton-control-field" }
const _hoisted_42 = { class: "body-info-address" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = {
  key: 3,
  class: "skeleton-outlined"
}
const _hoisted_45 = { class: "skeleton-control" }
const _hoisted_46 = { class: "skeleton-control-field" }
const _hoisted_47 = {
  key: 5,
  class: "skeleton-outlined"
}
const _hoisted_48 = { class: "skeleton-control" }
const _hoisted_49 = { class: "skeleton-control-field" }
const _hoisted_50 = {
  key: 7,
  class: "skeleton-outlined"
}
const _hoisted_51 = { class: "skeleton-control" }
const _hoisted_52 = { class: "skeleton-control-field" }
const _hoisted_53 = {
  key: 9,
  class: "skeleton-outlined"
}
const _hoisted_54 = { class: "skeleton-control" }
const _hoisted_55 = { class: "skeleton-control-field" }
const _hoisted_56 = {
  key: 11,
  class: "skeleton-outlined"
}
const _hoisted_57 = { class: "skeleton-control" }
const _hoisted_58 = { class: "skeleton-control-field" }
const _hoisted_59 = { class: "skeleton-control-icon" }
const _hoisted_60 = {
  key: 13,
  class: "skeleton-outlined"
}
const _hoisted_61 = { class: "skeleton-control" }
const _hoisted_62 = { class: "skeleton-control-field" }
const _hoisted_63 = { class: "skeleton-control-icon" }
const _hoisted_64 = {
  key: 15,
  class: "skeleton-outlined"
}
const _hoisted_65 = { class: "skeleton-control" }
const _hoisted_66 = { class: "skeleton-control-field" }
const _hoisted_67 = { class: "skeleton-control-icon" }
const _hoisted_68 = {
  key: 17,
  class: "skeleton-outlined"
}
const _hoisted_69 = { class: "skeleton-control" }
const _hoisted_70 = { class: "skeleton-control-field" }
const _hoisted_71 = { class: "body-info-btn" }
const _hoisted_72 = { class: "btn-content-submit" }
const _hoisted_73 = { key: 0 }

export function render(_ctx, _cache) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_AlertMessage = _resolveComponent("AlertMessage")
  const _component_ModalEditMobilePage = _resolveComponent("ModalEditMobilePage")
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_q_skeleton = _resolveComponent("q-skeleton")
  const _component_q_input = _resolveComponent("q-input")
  const _component_q_select = _resolveComponent("q-select")
  const _component_q_icon = _resolveComponent("q-icon")
  const _component_q_btn = _resolveComponent("q-btn")
  const _component_q_item_section = _resolveComponent("q-item-section")
  const _component_q_item = _resolveComponent("q-item")
  const _component_LoadingButton = _resolveComponent("LoadingButton")
  const _component_q_form = _resolveComponent("q-form")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.isLoadingSpinner)
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.isAlertMessageActive)
      ? (_openBlock(), _createBlock(_component_AlertMessage, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.isModalEditMobilePageActive)
      ? (_openBlock(), _createBlock(_component_ModalEditMobilePage, {
          key: 2,
          customerProfileModel: _ctx.model,
          getCustomerProfileFn: _ctx.updateCustomerInfo
        }, null, 8, ["customerProfileModel", "getCustomerProfileFn"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(['modal-edit-profile-page', 'show', {hide: _ctx.isModalClose}])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "arrow",
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.closeModal()))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-chevron-left" })
            ]),
            _hoisted_5
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  class: _normalizeClass(['hide-active', { 'show-active': !_ctx.isSkeleton && _ctx.lineInfo.profile.pictureUrl }]),
                  src: _ctx.lineInfo.profile.pictureUrl,
                  alt: "Avatar"
                }, null, 10, _hoisted_9),
                _createElementVNode("img", {
                  class: _normalizeClass(['hide-active', { 'show-active': !_ctx.isSkeleton && !_ctx.lineInfo.profile.pictureUrl }]),
                  src: _imports_0,
                  alt: "Avatar"
                }, null, 2),
                _createVNode(_component_q_skeleton, {
                  class: _normalizeClass(['skeleton-circle', 'hide-active', { 'show-active': _ctx.isSkeleton }])
                }, null, 8, ["class"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                (!_ctx.isSkeleton)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.lineInfo.profile.displayName), 1),
                      _createElementVNode("img", {
                        src: _imports_1,
                        onClick: _cache[1] || (_cache[1] = $event => (_ctx.openModalUnlinkWhenIsNotSubmitting()))
                      })
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.isSkeleton)
                  ? (_openBlock(), _createBlock(_component_q_skeleton, {
                      key: 1,
                      class: "skeleton",
                      width: "166px",
                      height: "14px"
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_q_form, {
                greedy: "",
                onSubmit: _ctx.submitForm,
                onValidationError: _cache[18] || (_cache[18] = $event => (_ctx.onValidationError(_ctx.$refs)))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    (!_ctx.isSkeleton)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, "ข้อมูลทั่วไป (ภาษาไทย ตามบัตรประชาชน)"))
                      : _createCommentVNode("", true),
                    (_ctx.isSkeleton)
                      ? (_openBlock(), _createBlock(_component_q_skeleton, {
                          key: 1,
                          class: "skeleton skeleton-type-text"
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.isSkeleton)
                      ? (_openBlock(), _createBlock(_component_q_input, {
                          key: 2,
                          class: "q-pt-sm q-pb-xs",
                          outlined: "",
                          modelValue: _ctx.model.first_name,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.model.first_name) = $event)),
                          ref: "first_nameInput",
                          label: "ชื่อ",
                          "no-error-icon": "",
                          "hide-bottom-space": "",
                          clearable: "",
                          maxlength: "50",
                          disable: _ctx.isSubmit,
                          rules: [val => val && val.length || 'กรุณากรอกชื่อ']
                        }, null, 8, ["modelValue", "disable", "rules"]))
                      : _createCommentVNode("", true),
                    (_ctx.isSkeleton)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-label" }),
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-value" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isSkeleton)
                      ? (_openBlock(), _createBlock(_component_q_input, {
                          key: 4,
                          class: "q-pt-sm q-pb-xs",
                          outlined: "",
                          modelValue: _ctx.model.last_name,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.model.last_name) = $event)),
                          ref: "last_nameInput",
                          label: "นามสกุล",
                          "no-error-icon": "",
                          "hide-bottom-space": "",
                          clearable: "",
                          maxlength: "50",
                          disable: _ctx.isSubmit,
                          rules: [val => val && val.length || 'กรุณากรอกนามสกุล']
                        }, null, 8, ["modelValue", "disable", "rules"]))
                      : _createCommentVNode("", true),
                    (_ctx.isSkeleton)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-label" }),
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-value" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isSkeleton)
                      ? (_openBlock(), _createBlock(_component_q_select, {
                          key: 6,
                          class: "q-pt-sm q-pb-xs",
                          outlined: "",
                          modelValue: _ctx.model.gender,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.model.gender) = $event)),
                          behavior: "menu",
                          options: _ctx.genderOptions,
                          disable: _ctx.isSubmit,
                          label: "เพศ",
                          "emit-value": "",
                          "map-options": ""
                        }, null, 8, ["modelValue", "options", "disable"]))
                      : _createCommentVNode("", true),
                    (_ctx.isSkeleton)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-label" }),
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-value" })
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-icon" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isSkeleton)
                      ? (_openBlock(), _createBlock(_component_q_input, {
                          key: 8,
                          class: "q-pt-sm q-pb-xs",
                          standout: "",
                          modelValue: _ctx.model.date_of_birth,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.model.date_of_birth) = $event)),
                          label: "วัน/เดือน/ปี พ.ศ. เกิด",
                          readonly: ""
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "info",
                              onClick: _ctx.onShowTooltipDateOfBirth
                            }, null, 8, ["onClick"]),
                            _createElementVNode("span", {
                              class: _normalizeClass(['tooltip', {active: _ctx.isTooltipDateOfBirth}])
                            }, _toDisplayString(_ctx.textTooltip), 3)
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    (_ctx.isSkeleton)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-label" }),
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-value" })
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-icon" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isSkeleton)
                      ? (_openBlock(), _createBlock(_component_q_input, {
                          key: 10,
                          class: "q-pt-sm q-pb-xs",
                          standout: "",
                          modelValue: _ctx.model.national_id,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.model.national_id) = $event)),
                          label: "เลขบัตรประชาชน",
                          readonly: ""
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "info",
                              onClick: _ctx.onShowTooltipNationalID
                            }, null, 8, ["onClick"]),
                            _createElementVNode("span", {
                              class: _normalizeClass(['tooltip', {active: _ctx.isTooltipNationalID}])
                            }, _toDisplayString(_ctx.textTooltip), 3)
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    (_ctx.isSkeleton)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-label" }),
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-value" })
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-icon" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    (!_ctx.isSkeleton)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, "ข้อมูลการติดต่อ"))
                      : _createCommentVNode("", true),
                    (_ctx.isSkeleton)
                      ? (_openBlock(), _createBlock(_component_q_skeleton, {
                          key: 1,
                          class: "skeleton skeleton-type-text"
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.isSkeleton)
                      ? (_openBlock(), _createBlock(_component_q_input, {
                          key: 2,
                          class: "q-pt-sm q-pb-xs",
                          outlined: "",
                          modelValue: _ctx.model.phone_number,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.model.phone_number) = $event)),
                          label: "เบอร์โทรศัพท์มือถือ",
                          readonly: ""
                        }, {
                          append: _withCtx(() => [
                            (!_ctx.isSkeleton && _ctx.isEnabledEditMobileNumber)
                              ? (_openBlock(), _createBlock(_component_q_btn, {
                                  key: 0,
                                  class: "btn btn-edit-mobile",
                                  unelevated: "",
                                  type: "button",
                                  onClick: _ctx.editMobileNumber
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_34
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    (_ctx.isSkeleton)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-label" }),
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-value" })
                            ]),
                            _createElementVNode("div", _hoisted_38, [
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-btn" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isSkeleton)
                      ? (_openBlock(), _createBlock(_component_q_input, {
                          key: 4,
                          class: "q-pt-sm q-pb-xs",
                          outlined: "",
                          modelValue: _ctx.model.email,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.model.email) = $event)),
                          ref: "emailInput",
                          type: "email",
                          label: "อีเมล (ถ้ามี)",
                          "no-error-icon": "",
                          "hide-bottom-space": "",
                          clearable: "",
                          maxlength: "50",
                          disable: _ctx.isSubmit,
                          onBlur: _cache[9] || (_cache[9] = () => !_ctx.checkFormatEmail(_ctx.$refs.emailInput.modelValue) ? _ctx.$refs.emailInput.validate() : _ctx.$refs.emailInput.resetValidation()),
                          "lazy-rules": "ondemand",
                          rules: [val => (!val || _ctx.checkFormatEmail(val)) || 'กรุณากรอกอีเมลที่ถูกต้อง']
                        }, null, 8, ["modelValue", "disable", "rules"]))
                      : _createCommentVNode("", true),
                    (_ctx.isSkeleton)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-label" }),
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-value" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    (!_ctx.isSkeleton)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_43, "ที่อยู่"))
                      : _createCommentVNode("", true),
                    (_ctx.isSkeleton)
                      ? (_openBlock(), _createBlock(_component_q_skeleton, {
                          key: 1,
                          class: "skeleton skeleton-type-text"
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.isSkeleton)
                      ? (_openBlock(), _createBlock(_component_q_input, {
                          key: 2,
                          class: "q-pt-sm q-pb-xs",
                          outlined: "",
                          modelValue: _ctx.model.address.address_number,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.model.address.address_number) = $event)),
                          ref: "address_numberInput",
                          label: "บ้านเลขที่",
                          "no-error-icon": "",
                          "hide-bottom-space": "",
                          clearable: "",
                          maxlength: "50",
                          disable: _ctx.isSubmit,
                          rules: [val => val && val.length || 'กรุณาใส่หมายเลขที่อยู่ของคุณ']
                        }, null, 8, ["modelValue", "disable", "rules"]))
                      : _createCommentVNode("", true),
                    (_ctx.isSkeleton)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("div", _hoisted_46, [
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-label" }),
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-value" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isSkeleton)
                      ? (_openBlock(), _createBlock(_component_q_input, {
                          key: 4,
                          class: "q-pt-sm q-pb-xs",
                          outlined: "",
                          modelValue: _ctx.model.address.th_moo,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.model.address.th_moo) = $event)),
                          label: "หมู่",
                          clearable: "",
                          maxlength: "10",
                          disable: _ctx.isSubmit
                        }, null, 8, ["modelValue", "disable"]))
                      : _createCommentVNode("", true),
                    (_ctx.isSkeleton)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-label" }),
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-value" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isSkeleton)
                      ? (_openBlock(), _createBlock(_component_q_input, {
                          key: 6,
                          class: "q-pt-sm q-pb-xs",
                          outlined: "",
                          modelValue: _ctx.model.address.th_soi,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_ctx.model.address.th_soi) = $event)),
                          label: "ซอย",
                          clearable: "",
                          maxlength: "50",
                          disable: _ctx.isSubmit
                        }, null, 8, ["modelValue", "disable"]))
                      : _createCommentVNode("", true),
                    (_ctx.isSkeleton)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("div", _hoisted_52, [
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-label" }),
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-value" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isSkeleton)
                      ? (_openBlock(), _createBlock(_component_q_input, {
                          key: 8,
                          class: "q-pt-sm q-pb-xs",
                          outlined: "",
                          modelValue: _ctx.model.address.th_road,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_ctx.model.address.th_road) = $event)),
                          label: "ถนน",
                          clearable: "",
                          maxlength: "50",
                          disable: _ctx.isSubmit
                        }, null, 8, ["modelValue", "disable"]))
                      : _createCommentVNode("", true),
                    (_ctx.isSkeleton)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, [
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-label" }),
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-value" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isSkeleton)
                      ? (_openBlock(), _createBlock(_component_q_select, {
                          key: 10,
                          class: "q-pt-sm q-pb-xs",
                          outlined: "",
                          modelValue: _ctx.model.address.th_province,
                          "onUpdate:modelValue": [
                            _cache[14] || (_cache[14] = $event => ((_ctx.model.address.th_province) = $event)),
                            _ctx.onChangeProvince
                          ],
                          ref: "address_provinceInput",
                          "use-input": "",
                          "no-error-icon": "",
                          "hide-bottom-space": "",
                          behavior: "menu",
                          options: _ctx.provinceOptions,
                          "option-value": "name_th",
                          "option-label": "name_th",
                          "emit-value": "",
                          "map-options": "",
                          onFilter: _ctx.filterProvince,
                          label: "จังหวัด",
                          disable: _ctx.isSubmit,
                          rules: [val => val && val.length || 'กรุณาเลือกจังหวัด']
                        }, {
                          "no-option": _withCtx(() => [
                            _createVNode(_component_q_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, { class: "text-grey" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.textNoResults), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "onFilter", "onUpdate:modelValue", "disable", "rules"]))
                      : _createCommentVNode("", true),
                    (_ctx.isSkeleton)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("div", _hoisted_58, [
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-label" }),
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-value" })
                            ]),
                            _createElementVNode("div", _hoisted_59, [
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-icon" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isSkeleton)
                      ? (_openBlock(), _createBlock(_component_q_select, {
                          key: 12,
                          class: "q-pt-sm q-pb-xs",
                          outlined: "",
                          modelValue: _ctx.model.address.th_district,
                          "onUpdate:modelValue": [
                            _cache[15] || (_cache[15] = $event => ((_ctx.model.address.th_district) = $event)),
                            _ctx.onChangeDistrict
                          ],
                          ref: "address_districtInput",
                          "use-input": "",
                          "no-error-icon": "",
                          "hide-bottom-space": "",
                          behavior: "menu",
                          readonly: !_ctx.model.address.th_province,
                          options: _ctx.districtOptions,
                          "option-value": "name_th",
                          "option-label": "name_th",
                          "emit-value": "",
                          "map-options": "",
                          onFilter: _ctx.filterDistrict,
                          label: "เขต/อำเภอ",
                          disable: _ctx.isSubmit,
                          rules: [val => val && val.length || 'กรุณาเลือกเขต/อำเภอ']
                        }, {
                          "no-option": _withCtx(() => [
                            _createVNode(_component_q_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, { class: "text-grey" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.textNoResults), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "readonly", "options", "onFilter", "onUpdate:modelValue", "disable", "rules"]))
                      : _createCommentVNode("", true),
                    (_ctx.isSkeleton)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                          _createElementVNode("div", _hoisted_61, [
                            _createElementVNode("div", _hoisted_62, [
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-label" }),
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-value" })
                            ]),
                            _createElementVNode("div", _hoisted_63, [
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-icon" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isSkeleton)
                      ? (_openBlock(), _createBlock(_component_q_select, {
                          key: 14,
                          class: "q-pt-sm q-pb-xs",
                          outlined: "",
                          modelValue: _ctx.model.address.th_sub_district,
                          "onUpdate:modelValue": [
                            _cache[16] || (_cache[16] = $event => ((_ctx.model.address.th_sub_district) = $event)),
                            _ctx.onChangeSubDistrict
                          ],
                          ref: "address_sub_districtInput",
                          "use-input": "",
                          "no-error-icon": "",
                          "hide-bottom-space": "",
                          behavior: "menu",
                          readonly: !_ctx.model.address.th_district,
                          options: _ctx.subDistrictOptions,
                          "option-value": "name_th",
                          "option-label": "name_th",
                          "emit-value": "",
                          "map-options": "",
                          onFilter: _ctx.filterSubDistrict,
                          label: "แขวง/ตำบล",
                          disable: _ctx.isSubmit,
                          rules: [val => val && val.length || 'กรุณาเลือกแขวง/ตำบล']
                        }, {
                          "no-option": _withCtx(() => [
                            _createVNode(_component_q_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, { class: "text-grey" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.textNoResults), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "readonly", "options", "onFilter", "onUpdate:modelValue", "disable", "rules"]))
                      : _createCommentVNode("", true),
                    (_ctx.isSkeleton)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("div", _hoisted_66, [
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-label" }),
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-value" })
                            ]),
                            _createElementVNode("div", _hoisted_67, [
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-icon" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isSkeleton)
                      ? (_openBlock(), _createBlock(_component_q_input, {
                          key: 16,
                          class: "q-pt-sm q-pb-xs",
                          outlined: "",
                          modelValue: _ctx.model.address.postal_code,
                          "onUpdate:modelValue": [
                            _cache[17] || (_cache[17] = $event => ((_ctx.model.address.postal_code) = $event)),
                            _ctx.onChangePostalCode
                          ],
                          ref: "address_postal_codeInput",
                          label: "รหัสไปรษณีย์",
                          "no-error-icon": "",
                          "hide-bottom-space": "",
                          clearable: "",
                          maxlength: "5",
                          disable: _ctx.isSubmit,
                          rules: [val => val && val.length || 'กรุณากรอกรหัสไปรษณีย์', val => val.length === 5 || 'เฉพาะตัวเลขเท่านั้น (สูงสุด 5 ตัว)']
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disable", "rules"]))
                      : _createCommentVNode("", true),
                    (_ctx.isSkeleton)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("div", _hoisted_70, [
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-label" }),
                              _createVNode(_component_q_skeleton, { class: "skeleton skeleton-value" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    (!_ctx.isSkeleton)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 0,
                          class: "btn",
                          unelevated: "",
                          type: "submit",
                          disable: _ctx.isSubmit
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_72, [
                              (!_ctx.isSubmit)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_73, "บันทึก"))
                                : _createCommentVNode("", true),
                              (_ctx.isSubmit)
                                ? (_openBlock(), _createBlock(_component_LoadingButton, { key: 1 }))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        }, 8, ["disable"]))
                      : _createCommentVNode("", true),
                    (_ctx.isSkeleton)
                      ? (_openBlock(), _createBlock(_component_q_skeleton, {
                          key: 1,
                          class: "skeleton",
                          type: "QBtn",
                          width: "100%"
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit"])
            ])
          ])
        ])
      ])
    ], 2)
  ]))
}